import moment from "moment";

const DeliveryTableView = ({ delivery }) => {
  const lines = delivery.move_ids_without_package;

  return (
    <div className="-mx-2">
      <table>
        <tbody>
          <tr>
            <td>
              🗓️{" "}
              <b>
                {moment
                  .utc(delivery.date_done)
                  .local()
                  .format("YYYY-MM-DD HH:mm")}
              </b>{" "}
              <span className="">{delivery.name}</span>
            </td>
            <td className="text-right pr-0"></td>
          </tr>
          {lines.map((line) => (
            <tr key={line.id} className="border-y border-gray-100">
              <td className="">
                <div>
                  <div>{line.product_id.display_name}</div>
                  <div>{line.product_id.description_purchase}</div>
                </div>
              </td>
              <td className="text-right">&times; {line.product_qty}</td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default DeliveryTableView;
